// HorizontalBarChart.tsx
import { Select, Spin } from "antd";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { formatNumber } from "../../../../services/mixin";
import { dataSelectTopReport } from "../../ReportCustomer";
import CustomYAxisTick from "./CustomYAxisTick";
import { formatPrice } from "../../../../until";
import TooltipComponent from "../../../../components/TooltipComponent";
import { IDataDefaulFilter, TYPEFILTERTOP } from "..";
import { useNavigate } from "react-router-dom";
import { noData } from "../../../../components/ExportImgFigma";

interface CustomYAxisTickProps {
    x?: number;
    y?: number;
    payload?: {
        value: string;
    };
}

const MAX_CHARS_PER_LINE = 18; // chỉnh theo width 140
const MAX_LINES = 2;

const splitText = (text: string) => {
    const words = text.split(" ");
    const lines: string[] = [];
    let currentLine = "";

    for (const word of words) {
        if ((currentLine + " " + word).length <= MAX_CHARS_PER_LINE) {
            currentLine = currentLine ? `${currentLine} ${word}` : word;
        } else {
            lines.push(currentLine);
            currentLine = word;
        }
    }

    if (currentLine) lines.push(currentLine);

    return lines;
};


interface props {
    type: TYPEFILTERTOP;
    title: string;
    data?: any[];
    valueTop: Record<TYPEFILTERTOP, number>
    setValueTop: React.Dispatch<React.SetStateAction<Record<TYPEFILTERTOP, number>>>
    color: string;
    dataFilter: IDataDefaulFilter | undefined

}

export const HorizontalBarChart: React.FC<props> = ({
    type, title, dataFilter,
    data, color, valueTop,
    setValueTop

}) => {
    const navigate = useNavigate()

    const handleNavigate = (e: any) => {
        if (type === TYPEFILTERTOP.ADDRESS) {
            navigate(
                `/analysis-report/member-card-list`,
                {
                    state: {
                        type: 4,
                        listUnit: dataFilter?.unitIds,
                        listRank: dataFilter?.rankIds,
                        fromMonth: dataFilter?.fromMonth,
                        toMonth: dataFilter?.toMonth,
                        provinceId: e.activePayload[0].payload.id,
                        title: `Khách hàng ở khu vực ${e.activePayload[0].payload.name}`

                    }
                }
            )
        } else {
            navigate(
                `/analysis-report/member-card-list`,
                {
                    state: {
                        type: 5,
                        listUnit: dataFilter?.unitIds,
                        listRank: dataFilter?.rankIds,
                        fromMonth: dataFilter?.fromMonth,
                        toMonth: dataFilter?.toMonth,
                        professionId: e.activePayload[0].payload.id,
                        title: `Khách hàng có nghề nghiệp ${e.activePayload[0].payload.name}`
                    }
                }
            )
        }
    }

    return (
        <div className="custom-pape-css w-full bg-white rounded-2 p-4"
            style={{ border: '1px solid #eaebec' }}
        >
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
                <div className="custom-pape-css flex gap-1 items-center ">
                    <span className="custom-page-css text-base text-344054 font-medium ">{title}</span>
                    {/* <TooltipComponent value={tooltipValue} /> */}
                </div>
                <Select
                    size="small"
                    bordered={false}
                    value={valueTop[type]}
                    className="custom-page-css  border rounded px-1 py-2 text-344054"
                    options={dataSelectTopReport}
                    onSelect={(e) => setValueTop(prev => ({
                        ...prev,
                        [type]: e,
                    }))}
                />
            </div>

            {/* Chart */}
            <div style={{ width: "100%", height: 500 }}>
                {data && data?.length > 0 ?
                    <ResponsiveContainer>
                        <BarChart
                            dataKey="KIA"
                            layout="vertical"
                            data={data}
                            margin={{ left: 10, right: 20 }}
                            onClick={(e) => handleNavigate(e)}
                            width={30}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" tickFormatter={(value: number) => formatPrice(value)} />
                            <YAxis
                                type="category"
                                dataKey="name"
                                width={140}
                                tick={<CustomYAxisTick />}
                            />
                            {!!data?.length &&
                                <Tooltip
                                    labelFormatter={(label) => ` ${label}`}
                                    formatter={(value: number) => [`${formatNumber(value ?? 0)}`, 'Giá trị']}
                                />
                            }

                            <Bar
                                dataKey="value"
                                fill={color}
                                barSize={50}
                                maxBarSize={50}
                                radius={[0, 6, 6, 0]}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                    :
                    <div
                        style={{
                            textAlign: 'center',
                            padding: 20
                        }}>
                        <br />
                        <img src={noData} alt="No data"

                            style={{
                                maxWidth: 150,
                            }} />
                        <br />
                        <div>Không có dữ liệu</div>
                        <br />
                    </div>
                }


            </div>
        </div>
    );
};
